import React, { useState, useEffect } from "react";
import {IconImageM} from "@common/components/icons/IconsM";
import zoe_main from "@assets/champions/zoe_main.png"
import zoe_happy from "@assets/champions/zoe_happy.png"
import zoe_unhappy from "@assets/champions/zoe_unhappy.png"
import abou_main from "@assets/champions/abou_main.png"
import abou_happy from "@assets/champions/abou_happy.png"
import abou_unhappy from "@assets/champions/abou_unhappy.png"
import sam_main from "@assets/champions/sam_main.png"
import sam_happy from "@assets/champions/sam_happy.png"
import sam_unhappy from "@assets/champions/sam_unhappy.png"
import tina_main from "@assets/champions/tina_main.png"
import tina_happy from "@assets/champions/tina_happy.png"
import tina_unhappy from "@assets/champions/tina_unhappy.png"
import sam_animated from "@assets/animations/sam/sam-speaking2.webp"
import sam_animated_loop from "@assets/animations/sam/sam-waiting1.webp"

// Sam congrats animations
import sam_congrat2 from "@assets/animations/sam/sam-congrat2.webp"

// Zoe congrats animations
import zoe_congrat4 from "@assets/animations/zoe/zoe-congrat4.webp"
import zoe_congrat5 from "@assets/animations/zoe/zoe-congrat5.webp"

// Tina congrats animations
import tina_congrat10 from "@assets/animations/tina/tina-congrat10.webp"
import tina_congrat7 from "@assets/animations/tina/tina-congrat7.webp"

// Abou congrats animations
import abou_congrat10 from "@assets/animations/abou/abou-congrat10.webp"

import {Platform, View} from "react-native";
import {Image} from "expo-image";

const championImages = {
    zoe_main,
    zoe_happy,
    zoe_unhappy,
    abou_main,
    abou_happy,
    abou_unhappy,
    sam_main,
    sam_happy,
    sam_unhappy,
    tina_main,
    tina_happy,
    tina_unhappy
}

// Congrats animations for each champion
const congratsAnimations = {
    sam: [sam_congrat2],
    zoe: [zoe_congrat4, zoe_congrat5],
    tina: [tina_congrat7, tina_congrat10],
    abou: [abou_congrat10],
}

export const ChampionImageM = (props) => {

    const {name = "zoe", variant = "main", width, eye = false, style, height, animated = false, animationKey, isLoading = false, congratMode = false} = props

    // State for animation transition - must be at top level
    const [showLoopAnimation, setShowLoopAnimation] = useState(false)
    const [selectedCongratsAnimation] = useState(() => {
        // Randomly select a congrats animation for the current champion
        const championAnimations = congratsAnimations[name] || []
        if (championAnimations.length === 0) return null
        return championAnimations[Math.floor(Math.random() * championAnimations.length)]
    })

    const getSource = (name, variant) => {
        return championImages[`${name}_${variant}`]
    }

    // Effect for animation transition
    useEffect(() => {
        if (animated && name === "sam" && !isLoading && !congratMode) {
            setShowLoopAnimation(false)

            const timer = setTimeout(() => {
                setShowLoopAnimation(true)
            }, 6000)

            return () => clearTimeout(timer)
        }
    }, [animated, name, animationKey, isLoading, congratMode])

    if (congratMode && selectedCongratsAnimation) {
        const containerWidth = width;
        const containerHeight = height ? height : (width * 853 / 512);

        return (
            <View style={{
                width: containerWidth,
                height: containerHeight,
                overflow: 'visible',
                flexShrink: 0
            }}>
                <Image
                    source={selectedCongratsAnimation}
                    style={{
                        width: '100%',
                        height: '100%',
                        ...style
                    }}
                    contentFit="contain"
                />
            </View>
        )
    }

    if (animated && name === "sam") {
        const containerWidth = width;
        const containerHeight = height ? height : (width * 853 / 512);

        const animationSource = isLoading ? sam_animated_loop : (showLoopAnimation ? sam_animated_loop : sam_animated);

        return (
            <View style={{
                width: containerWidth,
                height: containerHeight,
                overflow: 'hidden',
                flexShrink: 0
            }}>
                <Image
                    source={animationSource}
                    style={{
                        width: '100%',
                        height: '100%',
                        ...style
                    }}
                    contentFit="cover"
                />
            </View>
        )
    }

    if (eye)
        return <Image
            source={getSource(name, variant)}
            style={{
                width: width,
                height: Platform.OS !== 'web' ? width/3.3 : width,
                ...style
            }}/>
    else
        return <IconImageM {...props}
                           source={getSource(name, variant)}
                           width={width}
                           style={style}
                           height={height? height : width*853/512}/>
}
export const samVariantForActivity = (activity) => activity?.score >= 4 ? "happy" : activity?.score < 2.5 ? "unhappy" : "main"
export const samVariantForScore = (score) => score >= 4 ? "happy" : score < 2.5 ? "unhappy" : "main"
